import { Button, ButtonVariants } from '@components/button/Button';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';
import { PageContent } from '../../../layout/PageContent';
import { PageHeader } from '../../../layout/PageHeader';
import { ListingForm } from '../form/ListingForm';
import { EditListingErrorModal } from './EditListingErrorModal';
import { EditListingWarningModal } from './EditListingWarningModal';
import { useEditListing } from './useEditListing';

export const EditListingPage = () => {
  const {
    closeErrorModal,
    closeWarningModal,
    control,
    errorModalData,
    floorPlans,
    handleOnClickSave,
    handleOnClickConfirm,
    hideListingsTerminology,
    isErrorModalOpen,
    isWarningModalOpen,
    referrer,
    warningModalData,
    setValue,
    resetField,
  } = useEditListing();

  if (!floorPlans.length) return null;

  const pageTitle = hideListingsTerminology ? 'Edit Table' : 'Edit Listing';
  const saveButtonLabel = hideListingsTerminology
    ? 'Publish Table Edits'
    : 'Save Listing';

  return (
    <>
      <PageHeader category="Operations" title={pageTitle}>
        <LinkStyledAsButton
          label="Cancel"
          to={referrer}
          variant={ButtonVariants.Tertiary}
        />
        <Button
          label={saveButtonLabel}
          variant={ButtonVariants.Primary}
          type="button"
          onClick={handleOnClickSave}
        />
      </PageHeader>
      <PageContent>
        <ListingForm
          control={control}
          setValue={setValue}
          resetField={resetField}
          hideListingsTerminology={hideListingsTerminology}
          floorPlans={floorPlans}
          isNewListing={false}
        />
      </PageContent>
      <EditListingErrorModal
        isOpen={isErrorModalOpen}
        closeModal={closeErrorModal}
        message={errorModalData?.message}
      />
      <EditListingWarningModal
        isOpen={isWarningModalOpen}
        closeModal={closeWarningModal}
        warnings={warningModalData?.warnings}
        confirm={handleOnClickConfirm}
      />
    </>
  );
};
